import React, { useEffect } from "react";

// import Header from "../../../Components/header";
// import Footer from "../../../Components/footer";
// import Pagination from "../../../Components/pagination";
// import errorImg from "../error_img.svg";


function Forbidden() {

  useEffect(()=>{
    
    window.location = "login";

  },[]);

  return (
        <>
          {/* <Header /> */}
          <section className="main-content">
            <div className="container-fluid">
              <div className="row mt-3">
                <div className="col-md-12 d-flex align-items-center justify-content-center flex-column">
                  {/* <img src={errorImg} alt="" width="200"/> */}
                  <h1 className="text-muted">OOPS! MISSING PERMESSIONS</h1>
                  <h5>This page is not publically available.</h5>
                </div>
              </div>
            </div>
          </section>
          {/* <Footer /> */}
        </>
  )
}

export default Forbidden;
